import { IncentiveCategory } from '@varo/graphql-schema-types';
import IncentiveResolverScreen from 'features/incentive/screens/IncentiveResolverScreen/IncentiveResolverScreen';
import useSweepstakesPrerequisite from 'features/incentive/sweepstakes/hooks/useSweepstakesPrerequisite';

function SweepstakesIncentiveScreen() {
  const prerequisite = useSweepstakesPrerequisite();

  return (
    <IncentiveResolverScreen
      incentiveType={IncentiveCategory.Sweepstakes}
      prerequisite={prerequisite}
    />
  );
}

export default SweepstakesIncentiveScreen;
